import React from "react";
import { IonText } from "@ionic/react";

const locale = "en-AU"; // TODO - add locale to config
const options = {
  month: "short",
  day: "numeric",
  timeZone: "Australia/Sydney",
};

function formatISODate(dString) {
  const formattedDate = new Intl.DateTimeFormat(locale, options).format(
    Date.parse(dString)
  );
  return formattedDate;
}

const DateMini = ({ date = new Date().toISOString(), color = "" }) => {
  return <IonText color={color}>{formatISODate(date)}</IonText>;
};

export default DateMini;
